import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// 🔹 Add or Update Item
export async function addItem(item_data) {
  try {
    const fd = new FormData();
    fd.append("item_data", btoa(JSON.stringify(item_data)));

    const response = await axios.post(`${apiBaseUrl}item/add_item`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("addItem error:", error);
    return { status: false, type: "danger", success: "Failed to save item" };
  }
}

// 🔹 Get Items List
export async function getItems(page_no = 0,item_updated_by="", search_key = "") {
  try {
    const fd = new FormData();
    fd.append("page_no", page_no);
    fd.append("search_key", search_key);
    fd.append("item_updated_by", item_updated_by);
    

    const response = await axios.post(`${apiBaseUrl}item/get_items`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getItems error:", error);
    return { status: false, type: "danger", success: "Failed to fetch items" };
  }
}

// 🔹 Delete Item
export async function deleteItem(item_id) {
  try {
    const fd = new FormData();
    fd.append("item_id", item_id);

    const response = await axios.post(`${apiBaseUrl}item/delete_item`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("deleteItem error:", error);
    return { status: false, type: "danger", success: "Failed to delete item" };
  }
}

// 🔹 Get Item By ID
export async function getItemById(item_id) {
  try {
    const fd = new FormData();
    fd.append("item_id", item_id);

    const response = await axios.post(`${apiBaseUrl}item/get_item_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getItemById error:", error);
    return { status: false, type: "danger", success: "Failed to fetch item" };
  }
}

export async function importItems(file,item_updated_by) {
  try {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("item_updated_by", item_updated_by);

    const response = await axios.post(
      `${apiBaseUrl}item/import_items`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("importItems error:", error);
    return { status: false, type: "danger", success: "Failed to import items" };
  }
}
export async function exportItems(item_updated_by) {
  try {
    const url = `${apiBaseUrl}item/export_items?item_updated_by=${item_updated_by}`;

    const response = await axios.get(url, { responseType: "blob" });

    const blob = new Blob([response.data], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "items_export.csv";
    link.click();

    return { status: true };
  } catch (error) {
    console.error("exportItems error:", error);
    return { status: false, type: "danger", success: "Failed to export items" };
  }
}
export async function downloadItemSample() {
  try {
    const url = `${apiBaseUrl}item/download_item_sample`;

    const response = await axios.get(url, { responseType: "blob" });

    const blob = new Blob([response.data], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "item_sample.csv";
    link.click();

    return { status: true };
  } catch (error) {
    console.error("downloadItemSample error:", error);
    return { status: false, type: "danger", success: "Failed to download sample" };
  }
}

